import { useCallback } from "react";

import { ExtendedWindowMedical } from "@/types/gtm/MedicalEligibilityPageEvent";

const useGTMMedicalEligibilityAgreement = () => {
  const updateMedicalEligibilityAgreement = useCallback(
    (event: string, eventName: string) => {
      if (!window) return;

      if (event === "" || eventName === "") return;

      const extendedWindow = window as ExtendedWindowMedical;
      extendedWindow.dataLayer = extendedWindow.dataLayer || [];
      extendedWindow.dataLayer.push({
        event,
        event_name: eventName,
      });
    },
    []
  );

  return {
    updateMedicalEligibilityAgreement,
  };
};

export default useGTMMedicalEligibilityAgreement;
